// extracted by mini-css-extract-plugin
module.exports = {"container":"Icon_container__AJqKD","custom-size":"Icon_custom-size__UBe5o"};